import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
// Lazy load CodeMirror 6 editor + HTML language + theme to keep initial bundle light
const LazyEditor = React.lazy(async () => {
    const [{ default: CodeMirror }, htmlMod, viewMod, langCoreMod, highlightMod] = await Promise.all([
        import(/* webpackChunkName: "designer-cm" */ '@uiw/react-codemirror'),
        import(/* webpackChunkName: "designer-cm-html" */ '@codemirror/lang-html'),
        import(/* webpackChunkName: "designer-cm-view" */ '@codemirror/view'),
        import(/* webpackChunkName: "designer-cm-langcore" */ '@codemirror/language'),
        import(/* webpackChunkName: "designer-cm-tags" */ '@lezer/highlight'),
    ]);
    const html = htmlMod.html;
    const { EditorView } = viewMod;
    const mono = 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace';
    const { HighlightStyle, syntaxHighlighting } = langCoreMod;
    const { tags: t } = highlightMod;
    const darkTheme = EditorView.theme({
        '&': { backgroundColor: '#1e1e1e', color: '#d4d4d4' },
        '.cm-gutters': { backgroundColor: '#1e1e1e', color: '#858585', border: 'none' },
        '.cm-scroller': { overflow: 'auto', fontFamily: mono, fontSize: '13px', lineHeight: '1.5' },
        '.cm-content': { caretColor: '#ffffff', whiteSpace: 'pre-wrap', wordBreak: 'break-word' },
        '.cm-line': { whiteSpace: 'pre-wrap', wordBreak: 'break-word' },
        '.cm-selectionBackground, ::selection': { backgroundColor: '#264f78' },
    }, { dark: true });
    const Editor = ({ value, onChange, readOnly }) => (_jsx(CodeMirror, { value: value, height: "100%", theme: darkTheme, basicSetup: { lineNumbers: true, foldGutter: false, highlightActiveLine: false }, extensions: [
            html(),
            EditorView.lineWrapping,
            darkTheme,
            // Softer syntax colors
            syntaxHighlighting(HighlightStyle.define([
                { tag: [t.keyword, t.atom], color: '#b39ddb' }, // soften purple/blue
                { tag: [t.tagName, t.propertyName], color: '#82aaff' },
                { tag: [t.attributeName, t.attributeValue], color: '#c3e88d' },
                { tag: [t.string], color: '#c3e88d' },
                { tag: [t.number, t.integer, t.float], color: '#f2ae7e' },
                { tag: [t.unit, t.modifier], color: '#b39ddb' },
                { tag: [t.operator, t.punctuation], color: '#a6accd' },
                { tag: [t.function(t.variableName), t.function(t.name)], color: '#b39ddb' }, // e.g., clamp()
                { tag: [t.comment], color: '#6b778d' },
                { tag: [t.variableName], color: '#a6accd' },
            ])),
        ], onChange: (v) => onChange(v), editable: !readOnly, style: { fontFamily: mono, background: '#1e1e1e', height: '100%', touchAction: 'pan-y' } }));
    return { default: Editor };
});
const DesignerCodeEditor = (props) => {
    return (_jsx(React.Suspense, { fallback: _jsx("div", { style: { padding: 12, color: 'var(--mantine-color-dimmed)' }, children: "Loading editor\u2026" }), children: _jsx(LazyEditor, { ...props }) }));
};
export default DesignerCodeEditor;
